import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import ReactApexChart from "react-apexcharts";
import TicketListModal from "../../core/modals/ticketListModal";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../core/data/redux/store";
import { fetchAllTasksAction, fetchTaskDataAction, saveTaskAction } from "../../core/data/redux/actions/TaskActions";
import moment from "moment";
import Select from "react-select";
import Loader from "../Loader/Loader";
import { isloading } from "../../core/data/redux/reducer/LoadingReducer";

const Tickets = () => {
  const location = useLocation();
  let stateprop = location.state?.state;
  const routes = all_routes;
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [tickets, setTickets] = useState<any[]>([]);
  const [page, setPage] = useState<any>(0);
  const [hasMore, setHasMore] = useState<any>(true);
  const pageSize = 10;
  const fetchedTickets = useSelector((state: RootState) => state.task.tasks.taskData);
  const categoriesCount = useSelector((state: RootState) => state.task.tasks.categoriesCount);
  const usersCount = useSelector((state: RootState) => state.task.tasks.usersCount);
  const [sortedTickets, setSortedTickets] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const masters = useSelector((state: RootState) => state.admin.masters);
  const initialFilters = {
    status: null,
    date: null,
    type: null,
    sort: 'latest',
    assignedTo: null,
    state: null,
  };
  const [filters, setFilters] = useState<any>({});
  const [projectChoose, setProjectChoose] = useState<any>([]);
  const [users, setUsers] = useState<any>([]);
  const [statusChoose, setStatusChoose] = useState<any>([]);
  const [priorityChoose, setPriorityChoose] = useState<any>([]);
  useEffect(() => {
    setLoading(true)
    dispatch(fetchTaskDataAction());
    setFilters(() => ({ ...initialFilters, state: stateprop }));
    setTimeout(() => {
      setLoading(false)
    }, 1000)

  }, []);


  useEffect(() => {
    setLoading(true)
    setSortedTickets([]);
    setPage(0);
    if (Object.keys(filters).length !== 0)
      dispatch(fetchAllTasksAction(0, pageSize, filters))
    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }, [filters]);
  useEffect(() => {

    if (fetchedTickets?.content) {
      if (page === 0) {
        setTickets(fetchedTickets.content);
      } else {
        setTickets((prevTickets) => [...prevTickets, ...fetchedTickets.content]);
      }
      setHasMore(fetchedTickets.content.length === pageSize);
    }

  }, [fetchedTickets]);
  useEffect(() => {

    const filteredTickets = tickets?.filter((ticket) => {
      return (
        (filters.status ? ticket.status === filters.status : true) &&
        (filters.date ? ticket.dueDate === filters.date : true) &&
        (filters.type ? ticket.taskType === filters.type : true) &&
        (filters.assignedTo ? ticket.assignedTo === filters.assignedTo : true)
      );
    });

    setSortedTickets(filteredTickets?.sort((a, b) => {
      if (filters.sort === 'latest') {
        return new Date(b.dueDate).getTime() - new Date(a.dueDate).getTime();
      } else {
        return new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime();
      }
    }));


  }, [tickets]);

  useEffect(() => {

    if (masters) {
      const categories = masters.taskTypes?.map((data: any) => ({
        value: data,
        label: data,
      })) || [];

      const statuses = masters.taskStatuses?.map((data: any) => ({
        value: data,
        label: data,
      })) || [];

      const priorities = masters.taskPriority?.map((data: any) => ({
        value: data,
        label: data,
      })) || [];

      const userOptions = masters.users?.map((data: any) => ({
        value: data.userName,
        label: data.name,
      })) || [];

      setProjectChoose([{ value: "", label: "Select Department" }, ...categories]);
      setStatusChoose([{ value: "", label: "Select Status" }, ...statuses]);
      setPriorityChoose([{ value: "", label: "Select Priority" }, ...priorities]);
      setUsers([{ value: "", label: "Select User" }, ...userOptions]);
    }

  }, [masters]);

  const handleFilterChange = (e: any) => {
    const { name, value } = e.target;
    setFilters((prevFilters: any) => ({
      ...prevFilters,
      [name]: value,
    }));
  };
  const handleFilterSelectchange = (selectedOption: any, actionMeta: any) => {
    setFilters((prevData: any) => ({
      ...prevData,
      [actionMeta.name]: selectedOption.value,
    }));
  };
  const colorMap = new Map();
  const colors = [
    'badge-primary',
    'badge-danger',
    'badge-success',
    'badge-warning',
    'badge-info',
    'bg-soft-pink',
    'bg-soft-yellow',
    'bg-soft-cyan',
    'bg-soft-purple',
  ];
  const colorss = [
    'primary',
    'danger',
    'success',
    'warning',
    'info',
  ];

  let colorIndex = 0;

  const getColorForValue = (value: any) => {
    if (!value) return 'badge-secondary';
    if (colorMap.has(value)) {
      return colorMap.get(value);
    }
    const color = colors[colorIndex % colors.length];
    colorMap.set(value, color);
    colorIndex++;
    return color;
  };
  const getColor = (value: any) => {
    if (!value) return 'secondary';
    if (colorMap.has(value)) {
      return colorMap.get(value);
    }
    const color = colorss[colorIndex % colorss.length];
    colorMap.set(value, color);
    colorIndex++;
    return color;
  };

  const loadMore = () => {
    setLoading(true)
    dispatch(fetchAllTasksAction(page + 1, pageSize, filters));
    setPage(page + 1);

    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }
  function getColorByDueDate(dueDate: any) {
    if (moment(dueDate).isBefore(moment())) {
      return 'badge-danger';
    } else {
      return 'bg-outline-success';
    }
  }

  return (
    <>
      {loading ?

        (<Loader />) : (
          <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
              <div className="content">
                {/* Breadcrumb */}
                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                  <div className="my-auto mb-2">
                    <h2 className="mb-1">Tasks</h2>
                    <nav>
                      <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                          <Link to={routes.adminDashboard}>
                            <i className="ti ti-smart-home" />
                          </Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                          All Tasks
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                    {/* <div className="me-2 mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as PDF
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div> */}
                    <div className="mb-2">
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#add_ticket"
                        className="btn btn-primary d-flex align-items-center"
                      >
                        <i className="ti ti-circle-plus me-2" />
                        Create Task
                      </Link>
                    </div>
                    <div className="head-icons ms-2">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
                {/* /Breadcrumb */}
                {/* <div className="row">
            <div className="col-xl-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body">
                  <div className="row">
                    <div className="col-6 d-flex">
                      <div className="flex-fill">
                        <div className="border border-dashed border-primary rounded-circle d-inline-flex align-items-center justify-content-center p-1 mb-3">
                          <span className="avatar avatar-lg avatar-rounded bg-primary-transparent ">
                            <i className="ti ti-ticket fs-20" />
                          </span>
                        </div>
                        <p className="fw-medium fs-12 mb-1">New Tickets</p>
                        <h4>120</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body">
                  <div className="row">
                    <div className="col-6 d-flex">
                      <div className="flex-fill">
                        <div className="border border-dashed border-purple rounded-circle d-inline-flex align-items-center justify-content-center p-1 mb-3">
                          <span className="avatar avatar-lg avatar-rounded bg-transparent-purple">
                            <i className="ti ti-folder-open fs-20" />
                          </span>
                        </div>
                        <p className="fw-medium fs-12 mb-1">Open Tickets</p>
                        <h4>60</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body">
                  <div className="row">
                    <div className="col-6 d-flex">
                      <div className="flex-fill">
                        <div className="border border-dashed border-success rounded-circle d-inline-flex align-items-center justify-content-center p-1 mb-3">
                          <span className="avatar avatar-lg avatar-rounded bg-success-transparent">
                            <i className="ti ti-checks fs-20" />
                          </span>
                        </div>
                        <p className="fw-medium fs-12 mb-1">Solved Tickets</p>
                        <h4>50</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body">
                  <div className="row">
                    <div className="col-6 d-flex">
                      <div className="flex-fill">
                        <div className="border border-dashed border-info rounded-circle d-inline-flex align-items-center justify-content-center p-1 mb-3">
                          <span className="avatar avatar-lg avatar-rounded bg-info-transparent">
                            <i className="ti ti-progress-alert fs-20" />
                          </span>
                        </div>
                        <p className="fw-medium fs-12 mb-1">
                          Pending Tickets
                        </p>
                        <h4>10</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
                <div className="card">
                  <div className="card-body p-3">
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h5>Tasks List {stateprop && <>
                        {stateprop == 'pending' && <span className={`badge badge-warning me-3`}>
                          <i className="ti ti-circle-filled fs-5 me-1" />
                          {stateprop.toUpperCase()}
                        </span>}
                        {stateprop == 'completed' && <span className={`badge badge-success me-3`}>
                          <i className="ti ti-circle-filled fs-5 me-1" />
                          {stateprop.toUpperCase()}
                        </span>}
                        {stateprop == 'overdue' && <span className={`badge badge-danger me-3`}>
                          <i className="ti ti-circle-filled fs-5 me-1" />
                          {stateprop.toUpperCase()}
                        </span>}
                      </>}</h5>
                      <div className="d-flex align-items-center flex-wrap row-gap-3">
                        <Select
                          name='priority'
                          id='priority'
                          className="react-select"
                          options={priorityChoose}
                          value={priorityChoose?.find((option: any) => option.value === filters.priority) || priorityChoose[0]}
                          placeholder="Select"
                          onChange={handleFilterSelectchange}
                        />
                        <Select
                          name='status'
                          id='status'
                          className="react-select ms-2"
                          options={statusChoose}
                          value={statusChoose?.find((option: any) => option.value === filters.status) || statusChoose[0]}
                          placeholder="Select"
                          onChange={handleFilterSelectchange}
                        />
                        <Link to="#" className="btn btn-icon m-1" onClick={() => setFilters(initialFilters)}>
                          <i className="ti ti-refresh" />
                        </Link>
                        {/* <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Sort By : Last 7 Days
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                        >
                          Recently Added
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                        >
                          Ascending
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                        >
                          Desending
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                        >
                          Last Month
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                        >
                          Last 7 Days
                        </Link>
                      </li>
                    </ul>
                  </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xl-9 col-md-8">

                    {sortedTickets?.length > 0 && sortedTickets.map((task: any, index: number) => (
                      <div className="card" key={index}>
                        <span className={`bookmark-sideleft-ribbone-${getColor(task.taskType)}-left`}>
                          <span>{task.taskType}</span>
                        </span>
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                          <h5 className="text-info fw-medium">

                          </h5>
                          <div className="d-flex align-items-center">
                            <span className={`badge ${getColorForValue(task.priority)} d-inline-flex align-items-center me-3`}>
                              <i className="ti ti-circle-filled fs-5 me-1" />
                              {task.priority}
                            </span>
                          </div>
                        </div>
                        <div className="card-body">
                          <div>
                            <div className="d-flex align-items-center justify-content-between">
                              <span className="badge bg-outline-info rounded-pill mb-2">
                                {task.id}
                              </span>
                              <span className={`badge ${getColorByDueDate(task.dueDate)} rounded-pill mx-2`}>
                                {task.dueDate ? moment(task.dueDate)?.format("DD-MMM-YYYY") : ''}
                              </span>
                            </div>
                            <div className="d-flex align-items-center mb-2">
                              <h5 className="fw-semibold me-2">
                                <Link to={`${routes.tasksdetails.replace(":taskId", task.id)}`}>{task.title}</Link>
                                {/* <Link to={routes.ticketDetails} onClick={()=>dispatch({type:SET_TASK,payload:task.id})}>{task.title}</Link> */}

                              </h5>
                              <span className="badge bg-outline-pink d-flex align-items-center ms-1">
                                <i className="ti ti-circle-filled fs-5 me-1" />
                                {task.status}
                              </span>
                            </div>
                            <div className="d-flex align-items-center flex-wrap row-gap-2">
                              <p className="d-flex align-items-center mb-0 me-2">
                                {task.assignedToImage ?
                                  <img
                                    src={`data:image/png;base64,${task.assignedToImage}`}
                                    className="avatar avatar-xs rounded-circle me-2"
                                    alt="img"
                                  /> :
                                  <ImageWithBasePath
                                    src="assets/img/profiles/avatar-12.jpg"
                                    className="avatar avatar-xs rounded-circle me-2"
                                    alt="img"
                                  />}
                                Assigned to{" "}
                                <span className="text-dark ms-1"> {task.assignedTo}</span>
                              </p>
                              <p className="d-flex align-items-center mb-0 me-2">
                                <i className="ti ti-calendar-bolt me-1" />
                                Last Updated {task.updatedOn ? moment(task.updatedOn)?.format("DD-MMM-YYYY hh:mm:ss A") : ''}
                              </p>
                              <p className="d-flex align-items-center mb-0">
                                <i className="ti ti-message-share me-1" />{task.comments || 0} Comments
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                    {hasMore == true && <div className="text-center mb-4">
                      <Link to={"#"} onClick={() => loadMore()} className="btn btn-primary">
                        <i className="ti ti-loader-3 me-1" />
                        Load More
                      </Link>
                    </div>}
                    {sortedTickets?.length === 0 &&
                      <div className="card" >

                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">


                        </div>
                        <div className="card-body">
                          <div>

                            <div className="">
                              <p className="text-center">
                                No Data Avaliable.
                              </p>

                            </div>

                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  <div className="col-xl-3 col-md-4">
                    <div className="card">
                      <div className="card-header">
                        <h4>Departments</h4>
                      </div>
                      <div className="card-body p-0">
                        <div className="d-flex flex-column">
                          {categoriesCount?.length > 0 &&
                            categoriesCount.map((project: any, index: number) => {
                              return <div className="d-flex align-items-center justify-content-between border-bottom p-3" key={index}>
                                <Link to="#" onClick={() => setFilters((prevFilters: any) => ({
                                  ...prevFilters,
                                  category: project.type,
                                }))}>{project.type}</Link>
                                <div className="d-flex align-items-center">
                                  <span className="badge badge-xs bg-dark rounded-circle">
                                    {project.total}
                                  </span>
                                </div>
                              </div>
                            })
                          }
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <h4>Users</h4>
                      </div>
                      <div className="card-body p-0">
                        <div className="d-flex flex-column">
                          {usersCount?.length > 0 &&
                            usersCount.map((user: any, index: number) => {
                              return <div className="d-flex align-items-center justify-content-between border-bottom p-3" key={index}>
                                <span className="d-flex align-items-center" onClick={() => setFilters((prevFilters: any) => ({
                                  ...prevFilters,
                                  assignedTo: user.type,
                                }))}>
                                  {user.image ?
                                    <img
                                      src={`data:image/png;base64,${user.image}`}
                                      className="avatar avatar-xs rounded-circle me-2"
                                      alt="img"
                                    /> :
                                    <ImageWithBasePath
                                      src="assets/img/profiles/avatar-12.jpg"
                                      className="avatar avatar-xs rounded-circle me-2"
                                      alt="img"
                                    />}
                                  {user.type}
                                </span>
                                <div className="d-flex align-items-center">
                                  <span className="badge badge-xs bg-dark rounded-circle">
                                    {user.total}
                                  </span>
                                </div>
                              </div>
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                <p className="mb-0">2025 © HKCL.</p>
                <p>
                  Designed &amp; Developed By{" "}
                  <Link to="https://hkcl.in" target="_blank" className="text-primary">
                    HKCL
                  </Link>
                </p>
              </div>
            </div>
            {/* /Page Wrapper */}

            <TicketListModal />

          </>)}
    </>
  );
};

export default Tickets;
